import { useEffect, useState } from "react";
import { X, Download, Share } from "lucide-react";

const DISMISS_KEY = "pwa_install_dismissed";

export default function InstallPWA() {
  const [deferred, setDeferred] = useState(null);
  const [show, setShow] = useState(false);
  const [isIOS, setIsIOS] = useState(false);

  useEffect(() => {
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.register("/sw.js").catch(() => {});
    }
    const standalone = window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone;
    if (standalone || localStorage.getItem(DISMISS_KEY)) return;

    const ios = /iphone|ipad|ipod/i.test(navigator.userAgent) && !window.MSStream;
    setIsIOS(ios);

    const onPrompt = (e) => {
      e.preventDefault();
      setDeferred(e);
      setShow(true);
    };
    window.addEventListener("beforeinstallprompt", onPrompt);
    if (ios) setShow(true);
    return () => window.removeEventListener("beforeinstallprompt", onPrompt);
  }, []);

  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    await deferred.userChoice.catch(() => {});
    setDeferred(null);
    setShow(false);
  };

  const dismiss = () => {
    localStorage.setItem(DISMISS_KEY, "1");
    setShow(false);
  };

  if (!show) return null;

  return (
    <div data-testid="pwa-install-banner" className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-6 sm:max-w-sm z-50 bg-forest text-white rounded-2xl shadow-2xl p-4 flex items-start gap-3 animate-in slide-in-from-bottom">
      <img src="/icons/icon-192.png" alt="Ata Angora" className="w-11 h-11 rounded-xl shrink-0" />
      <div className="flex-1 min-w-0">
        <p className="text-sm font-bold">Ata Angora Uygulaması</p>
        {isIOS ? (
          <p className="text-xs text-white/80 mt-0.5 leading-snug">
            Safari'de <Share className="inline w-3.5 h-3.5 -mt-0.5" /> Paylaş → "Ana Ekrana Ekle" ile uygulama gibi kullanın.
          </p>
        ) : (
          <p className="text-xs text-white/80 mt-0.5">Ana ekranınıza ekleyin, uygulama gibi kullanın.</p>
        )}
        {!isIOS && deferred && (
          <button data-testid="pwa-install-btn" onClick={install} className="mt-2 inline-flex items-center gap-1.5 bg-gold hover:bg-gold-dark text-forest-dark text-xs font-bold px-4 py-2 rounded-full transition-colors">
            <Download className="w-3.5 h-3.5" /> Yükle
          </button>
        )}
      </div>
      <button data-testid="pwa-install-close" onClick={dismiss} className="p-1 text-white/60 hover:text-white transition-colors" aria-label="Kapat">
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
